import Un, { isAxiosError as io } from "axios";
import { useMemo as so } from "react";
var We = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function L(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var S = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, co = S, Ce = !co(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), Vn = Ce, Kn = Function.prototype, Ir = Kn.call, uo = Vn && Kn.bind.bind(Ir, Ir), _ = Vn ? uo : function(e) {
  return function() {
    return Ir.apply(e, arguments);
  };
}, lo = _, G = lo({}.isPrototypeOf), he = function(e) {
  return e && e.Math === Math && e;
}, O = (
  // eslint-disable-next-line es/no-global-this -- safe
  he(typeof globalThis == "object" && globalThis) || he(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  he(typeof self == "object" && self) || he(typeof We == "object" && We) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || We || Function("return this")()
), vo = Ce, Wn = Function.prototype, gt = Wn.apply, yt = Wn.call, fo = typeof Reflect == "object" && Reflect.apply || (vo ? yt.bind(gt) : function() {
  return yt.apply(gt, arguments);
}), zn = _, po = zn({}.toString), ho = zn("".slice), U = function(e) {
  return ho(po(e), 8, -1);
}, go = U, yo = _, Mr = function(e) {
  if (go(e) === "Function") return yo(e);
}, Or = typeof document == "object" && document.all, $o = typeof Or > "u" && Or !== void 0, Hn = {
  all: Or,
  IS_HTMLDDA: $o
}, qn = Hn, mo = qn.all, w = qn.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === mo;
} : function(e) {
  return typeof e == "function";
}, Yn = {}, bo = S, E = !bo(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), So = Ce, ge = Function.prototype.call, V = So ? ge.bind(ge) : function() {
  return ge.apply(ge, arguments);
}, Nr = {}, Jn = {}.propertyIsEnumerable, Xn = Object.getOwnPropertyDescriptor, _o = Xn && !Jn.call({ 1: 2 }, 1);
Nr.f = _o ? function(r) {
  var t = Xn(this, r);
  return !!t && t.enumerable;
} : Jn;
var Me = function(e, r) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: r
  };
}, wo = _, Io = S, Oo = U, ze = Object, To = wo("".split), Zn = Io(function() {
  return !ze("z").propertyIsEnumerable(0);
}) ? function(e) {
  return Oo(e) === "String" ? To(e, "") : ze(e);
} : ze, le = function(e) {
  return e == null;
}, Eo = le, xo = TypeError, ve = function(e) {
  if (Eo(e)) throw xo("Can't call method on " + e);
  return e;
}, Po = Zn, Ro = ve, K = function(e) {
  return Po(Ro(e));
}, $t = w, Qn = Hn, Ao = Qn.all, x = Qn.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : $t(e) || e === Ao;
} : function(e) {
  return typeof e == "object" ? e !== null : $t(e);
}, W = {}, He = W, qe = O, ko = w, mt = function(e) {
  return ko(e) ? e : void 0;
}, Ne = function(e, r) {
  return arguments.length < 2 ? mt(He[e]) || mt(qe[e]) : He[e] && He[e][r] || qe[e] && qe[e][r];
}, Do = typeof navigator < "u" && String(navigator.userAgent) || "", ea = O, Ye = Do, bt = ea.process, St = ea.Deno, _t = bt && bt.versions || St && St.version, wt = _t && _t.v8, T, ke;
wt && (T = wt.split("."), ke = T[0] > 0 && T[0] < 4 ? 1 : +(T[0] + T[1]));
!ke && Ye && (T = Ye.match(/Edge\/(\d+)/), (!T || T[1] >= 74) && (T = Ye.match(/Chrome\/(\d+)/), T && (ke = +T[1])));
var ra = ke, It = ra, jo = S, Co = O, Mo = Co.String, ta = !!Object.getOwnPropertySymbols && !jo(function() {
  var e = /* @__PURE__ */ Symbol("symbol detection");
  return !Mo(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && It && It < 41;
}), No = ta, na = No && !Symbol.sham && typeof Symbol.iterator == "symbol", Lo = Ne, Fo = w, Bo = G, Go = na, Uo = Object, aa = Go ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var r = Lo("Symbol");
  return Fo(r) && Bo(r.prototype, Uo(e));
}, Vo = String, Lr = function(e) {
  try {
    return Vo(e);
  } catch {
    return "Object";
  }
}, Ko = w, Wo = Lr, zo = TypeError, Le = function(e) {
  if (Ko(e)) return e;
  throw zo(Wo(e) + " is not a function");
}, Ho = Le, qo = le, Fr = function(e, r) {
  var t = e[r];
  return qo(t) ? void 0 : Ho(t);
}, Je = V, Xe = w, Ze = x, Yo = TypeError, Jo = function(e, r) {
  var t, n;
  if (r === "string" && Xe(t = e.toString) && !Ze(n = Je(t, e)) || Xe(t = e.valueOf) && !Ze(n = Je(t, e)) || r !== "string" && Xe(t = e.toString) && !Ze(n = Je(t, e))) return n;
  throw Yo("Can't convert object to primitive value");
}, oa = { exports: {} }, Ot = O, Xo = Object.defineProperty, Zo = function(e, r) {
  try {
    Xo(Ot, e, { value: r, configurable: !0, writable: !0 });
  } catch {
    Ot[e] = r;
  }
  return r;
}, Qo = O, ei = Zo, Tt = "__core-js_shared__", ri = Qo[Tt] || ei(Tt, {}), Br = ri, Et = Br;
(oa.exports = function(e, r) {
  return Et[e] || (Et[e] = r !== void 0 ? r : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var ia = oa.exports, ti = ve, ni = Object, Gr = function(e) {
  return ni(ti(e));
}, ai = _, oi = Gr, ii = ai({}.hasOwnProperty), M = Object.hasOwn || function(r, t) {
  return ii(oi(r), t);
}, si = _, ci = 0, ui = Math.random(), li = si(1 .toString), Ur = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + li(++ci + ui, 36);
}, vi = O, fi = ia, xt = M, di = Ur, pi = ta, hi = na, J = vi.Symbol, Qe = fi("wks"), gi = hi ? J.for || J : J && J.withoutSetter || di, I = function(e) {
  return xt(Qe, e) || (Qe[e] = pi && xt(J, e) ? J[e] : gi("Symbol." + e)), Qe[e];
}, yi = V, Pt = x, Rt = aa, $i = Fr, mi = Jo, bi = I, Si = TypeError, _i = bi("toPrimitive"), wi = function(e, r) {
  if (!Pt(e) || Rt(e)) return e;
  var t = $i(e, _i), n;
  if (t) {
    if (r === void 0 && (r = "default"), n = yi(t, e, r), !Pt(n) || Rt(n)) return n;
    throw Si("Can't convert object to primitive value");
  }
  return r === void 0 && (r = "number"), mi(e, r);
}, Ii = wi, Oi = aa, Vr = function(e) {
  var r = Ii(e, "string");
  return Oi(r) ? r : r + "";
}, Ti = O, At = x, Tr = Ti.document, Ei = At(Tr) && At(Tr.createElement), sa = function(e) {
  return Ei ? Tr.createElement(e) : {};
}, xi = E, Pi = S, Ri = sa, ca = !xi && !Pi(function() {
  return Object.defineProperty(Ri("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), Ai = E, ki = V, Di = Nr, ji = Me, Ci = K, Mi = Vr, Ni = M, Li = ca, kt = Object.getOwnPropertyDescriptor;
Yn.f = Ai ? kt : function(r, t) {
  if (r = Ci(r), t = Mi(t), Li) try {
    return kt(r, t);
  } catch {
  }
  if (Ni(r, t)) return ji(!ki(Di.f, r, t), r[t]);
};
var Fi = S, Bi = w, Gi = /#|\.prototype\./, fe = function(e, r) {
  var t = Vi[Ui(e)];
  return t === Wi ? !0 : t === Ki ? !1 : Bi(r) ? Fi(r) : !!r;
}, Ui = fe.normalize = function(e) {
  return String(e).replace(Gi, ".").toLowerCase();
}, Vi = fe.data = {}, Ki = fe.NATIVE = "N", Wi = fe.POLYFILL = "P", zi = fe, Dt = Mr, Hi = Le, qi = Ce, Yi = Dt(Dt.bind), Fe = function(e, r) {
  return Hi(e), r === void 0 ? e : qi ? Yi(e, r) : function() {
    return e.apply(r, arguments);
  };
}, N = {}, Ji = E, Xi = S, ua = Ji && Xi(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), Zi = x, Qi = String, es = TypeError, z = function(e) {
  if (Zi(e)) return e;
  throw es(Qi(e) + " is not an object");
}, rs = E, ts = ca, ns = ua, ye = z, jt = Vr, as = TypeError, er = Object.defineProperty, os = Object.getOwnPropertyDescriptor, rr = "enumerable", tr = "configurable", nr = "writable";
N.f = rs ? ns ? function(r, t, n) {
  if (ye(r), t = jt(t), ye(n), typeof r == "function" && t === "prototype" && "value" in n && nr in n && !n[nr]) {
    var a = os(r, t);
    a && a[nr] && (r[t] = n.value, n = {
      configurable: tr in n ? n[tr] : a[tr],
      enumerable: rr in n ? n[rr] : a[rr],
      writable: !1
    });
  }
  return er(r, t, n);
} : er : function(r, t, n) {
  if (ye(r), t = jt(t), ye(n), ts) try {
    return er(r, t, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw as("Accessors not supported");
  return "value" in n && (r[t] = n.value), r;
};
var is = E, ss = N, cs = Me, re = is ? function(e, r, t) {
  return ss.f(e, r, cs(1, t));
} : function(e, r, t) {
  return e[r] = t, e;
}, $e = O, us = fo, ls = Mr, vs = w, fs = Yn.f, ds = zi, H = W, ps = Fe, q = re, Ct = M, hs = function(e) {
  var r = function(t, n, a) {
    if (this instanceof r) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(t);
        case 2:
          return new e(t, n);
      }
      return new e(t, n, a);
    }
    return us(e, this, arguments);
  };
  return r.prototype = e.prototype, r;
}, P = function(e, r) {
  var t = e.target, n = e.global, a = e.stat, o = e.proto, s = n ? $e : a ? $e[t] : ($e[t] || {}).prototype, d = n ? H : H[t] || q(H, t, {})[t], l = d.prototype, v, c, f, u, i, p, y, g, $;
  for (u in r)
    v = ds(n ? u : t + (a ? "." : "#") + u, e.forced), c = !v && s && Ct(s, u), p = d[u], c && (e.dontCallGetSet ? ($ = fs(s, u), y = $ && $.value) : y = s[u]), i = c && y ? y : r[u], !(c && typeof p == typeof i) && (e.bind && c ? g = ps(i, $e) : e.wrap && c ? g = hs(i) : o && vs(i) ? g = ls(i) : g = i, (e.sham || i && i.sham || p && p.sham) && q(g, "sham", !0), q(d, u, g), o && (f = t + "Prototype", Ct(H, f) || q(H, f, {}), q(H[f], u, i), e.real && l && (v || !l[u]) && q(l, u, i)));
}, gs = Math.ceil, ys = Math.floor, $s = Math.trunc || function(r) {
  var t = +r;
  return (t > 0 ? ys : gs)(t);
}, ms = $s, Kr = function(e) {
  var r = +e;
  return r !== r || r === 0 ? 0 : ms(r);
}, bs = Kr, Ss = Math.max, _s = Math.min, la = function(e, r) {
  var t = bs(e);
  return t < 0 ? Ss(t + r, 0) : _s(t, r);
}, ws = Kr, Is = Math.min, va = function(e) {
  return e > 0 ? Is(ws(e), 9007199254740991) : 0;
}, Os = va, Be = function(e) {
  return Os(e.length);
}, Ts = K, Es = la, xs = Be, Mt = function(e) {
  return function(r, t, n) {
    var a = Ts(r), o = xs(a), s = Es(n, o), d;
    if (e && t !== t) {
      for (; o > s; )
        if (d = a[s++], d !== d) return !0;
    } else for (; o > s; s++)
      if ((e || s in a) && a[s] === t) return e || s || 0;
    return !e && -1;
  };
}, fa = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Mt(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Mt(!1)
}, Ps = P, Rs = fa.includes, As = S, ks = As(function() {
  return !Array(1).includes();
});
Ps({ target: "Array", proto: !0, forced: ks }, {
  includes: function(r) {
    return Rs(this, r, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Ds = W, de = function(e) {
  return Ds[e + "Prototype"];
}, js = de, Cs = js("Array").includes, Ms = x, Ns = U, Ls = I, Fs = Ls("match"), Bs = function(e) {
  var r;
  return Ms(e) && ((r = e[Fs]) !== void 0 ? !!r : Ns(e) === "RegExp");
}, Gs = Bs, Us = TypeError, da = function(e) {
  if (Gs(e))
    throw Us("The method doesn't accept regular expressions");
  return e;
}, Vs = I, Ks = Vs("toStringTag"), pa = {};
pa[Ks] = "z";
var Wr = String(pa) === "[object z]", Ws = Wr, zs = w, Te = U, Hs = I, qs = Hs("toStringTag"), Ys = Object, Js = Te(/* @__PURE__ */ (function() {
  return arguments;
})()) === "Arguments", Xs = function(e, r) {
  try {
    return e[r];
  } catch {
  }
}, pe = Ws ? Te : function(e) {
  var r, t, n;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = Xs(r = Ys(e), qs)) == "string" ? t : Js ? Te(r) : (n = Te(r)) === "Object" && zs(r.callee) ? "Arguments" : n;
}, Zs = pe, Qs = String, Ge = function(e) {
  if (Zs(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return Qs(e);
}, ec = I, rc = ec("match"), ha = function(e) {
  var r = /./;
  try {
    "/./"[e](r);
  } catch {
    try {
      return r[rc] = !1, "/./"[e](r);
    } catch {
    }
  }
  return !1;
}, tc = P, nc = _, ac = da, oc = ve, Nt = Ge, ic = ha, sc = nc("".indexOf);
tc({ target: "String", proto: !0, forced: !ic("includes") }, {
  includes: function(r) {
    return !!~sc(
      Nt(oc(this)),
      Nt(ac(r)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var cc = de, uc = cc("String").includes, Lt = G, lc = Cs, vc = uc, ar = Array.prototype, or = String.prototype, fc = function(e) {
  var r = e.includes;
  return e === ar || Lt(ar, e) && r === ar.includes ? lc : typeof e == "string" || e === or || Lt(or, e) && r === or.includes ? vc : r;
}, dc = fc, pc = dc, hc = pc, me = /* @__PURE__ */ L(hc), gc = U, yc = Array.isArray || function(r) {
  return gc(r) === "Array";
}, $c = _, mc = w, Er = Br, bc = $c(Function.toString);
mc(Er.inspectSource) || (Er.inspectSource = function(e) {
  return bc(e);
});
var Sc = Er.inspectSource, _c = _, wc = S, ga = w, Ic = pe, Oc = Ne, Tc = Sc, ya = function() {
}, Ec = [], $a = Oc("Reflect", "construct"), zr = /^\s*(?:class|function)\b/, xc = _c(zr.exec), Pc = !zr.exec(ya), ae = function(r) {
  if (!ga(r)) return !1;
  try {
    return $a(ya, Ec, r), !0;
  } catch {
    return !1;
  }
}, ma = function(r) {
  if (!ga(r)) return !1;
  switch (Ic(r)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Pc || !!xc(zr, Tc(r));
  } catch {
    return !0;
  }
};
ma.sham = !0;
var Rc = !$a || wc(function() {
  var e;
  return ae(ae.call) || !ae(Object) || !ae(function() {
    e = !0;
  }) || e;
}) ? ma : ae, Ft = yc, Ac = Rc, kc = x, Dc = I, jc = Dc("species"), Bt = Array, Cc = function(e) {
  var r;
  return Ft(e) && (r = e.constructor, Ac(r) && (r === Bt || Ft(r.prototype)) ? r = void 0 : kc(r) && (r = r[jc], r === null && (r = void 0))), r === void 0 ? Bt : r;
}, Mc = Cc, Nc = function(e, r) {
  return new (Mc(e))(r === 0 ? 0 : r);
}, Lc = Fe, Fc = _, Bc = Zn, Gc = Gr, Uc = Be, Vc = Nc, Gt = Fc([].push), ir = function(e) {
  var r = e === 1, t = e === 2, n = e === 3, a = e === 4, o = e === 6, s = e === 7, d = e === 5 || o;
  return function(l, v, c, f) {
    for (var u = Gc(l), i = Bc(u), p = Lc(v, c), y = Uc(i), g = 0, $ = f || Vc, m = r ? $(l, y) : t || s ? $(l, 0) : void 0, ne, Ke; y > g; g++) if ((d || g in i) && (ne = i[g], Ke = p(ne, g, u), e))
      if (r) m[g] = Ke;
      else if (Ke) switch (e) {
        case 3:
          return !0;
        // some
        case 5:
          return ne;
        // find
        case 6:
          return g;
        // findIndex
        case 2:
          Gt(m, ne);
      }
      else switch (e) {
        case 4:
          return !1;
        // every
        case 7:
          Gt(m, ne);
      }
    return o ? -1 : n || a ? a : m;
  };
}, Hr = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: ir(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: ir(1),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: ir(5)
}, Kc = P, Wc = Hr.find, Ut = "find", ba = !0;
Ut in [] && Array(1)[Ut](function() {
  ba = !1;
});
Kc({ target: "Array", proto: !0, forced: ba }, {
  find: function(r) {
    return Wc(this, r, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var zc = de, Hc = zc("Array").find, qc = G, Yc = Hc, sr = Array.prototype, Jc = function(e) {
  var r = e.find;
  return e === sr || qc(sr, e) && r === sr.find ? Yc : r;
}, Xc = Jc, Zc = Xc, Qc = Zc, eu = /* @__PURE__ */ L(Qc), ru = P, Sa = Mr, tu = va, Vt = Ge, nu = da, au = ve, ou = ha, Kt = Sa("".startsWith), iu = Sa("".slice), su = Math.min, cu = ou("startsWith");
ru({ target: "String", proto: !0, forced: !cu }, {
  startsWith: function(r) {
    var t = Vt(au(this));
    nu(r);
    var n = tu(su(arguments.length > 1 ? arguments[1] : void 0, t.length)), a = Vt(r);
    return Kt ? Kt(t, a, n) : iu(t, n, n + a.length) === a;
  }
});
var uu = de, lu = uu("String").startsWith, vu = G, fu = lu, cr = String.prototype, du = function(e) {
  var r = e.startsWith;
  return typeof e == "string" || e === cr || vu(cr, e) && r === cr.startsWith ? fu : r;
}, pu = du, hu = pu, gu = hu, yu = /* @__PURE__ */ L(gu), te = {}, $u = O, mu = w, Wt = $u.WeakMap, bu = mu(Wt) && /native code/.test(String(Wt)), Su = ia, _u = Ur, zt = Su("keys"), qr = function(e) {
  return zt[e] || (zt[e] = _u(e));
}, Ue = {}, wu = bu, _a = O, Iu = x, Ou = re, ur = M, lr = Br, Tu = qr, Eu = Ue, Ht = "Object already initialized", xr = _a.TypeError, xu = _a.WeakMap, De, se, je, Pu = function(e) {
  return je(e) ? se(e) : De(e, {});
}, Ru = function(e) {
  return function(r) {
    var t;
    if (!Iu(r) || (t = se(r)).type !== e)
      throw xr("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (wu || lr.state) {
  var R = lr.state || (lr.state = new xu());
  R.get = R.get, R.has = R.has, R.set = R.set, De = function(e, r) {
    if (R.has(e)) throw xr(Ht);
    return r.facade = e, R.set(e, r), r;
  }, se = function(e) {
    return R.get(e) || {};
  }, je = function(e) {
    return R.has(e);
  };
} else {
  var Y = Tu("state");
  Eu[Y] = !0, De = function(e, r) {
    if (ur(e, Y)) throw xr(Ht);
    return r.facade = e, Ou(e, Y, r), r;
  }, se = function(e) {
    return ur(e, Y) ? e[Y] : {};
  }, je = function(e) {
    return ur(e, Y);
  };
}
var Ve = {
  set: De,
  get: se,
  has: je,
  enforce: Pu,
  getterFor: Ru
}, Pr = E, Au = M, wa = Function.prototype, ku = Pr && Object.getOwnPropertyDescriptor, Ia = Au(wa, "name"), Du = Ia && (function() {
}).name === "something";
Ia && (!Pr || Pr && ku(wa, "name").configurable);
var ju = {
  PROPER: Du
}, Oa = {}, Cu = _, vr = M, Mu = K, Nu = fa.indexOf, Lu = Ue, qt = Cu([].push), Ta = function(e, r) {
  var t = Mu(e), n = 0, a = [], o;
  for (o in t) !vr(Lu, o) && vr(t, o) && qt(a, o);
  for (; r.length > n; ) vr(t, o = r[n++]) && (~Nu(a, o) || qt(a, o));
  return a;
}, Yr = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Fu = Ta, Bu = Yr, Ea = Object.keys || function(r) {
  return Fu(r, Bu);
}, Gu = E, Uu = ua, Vu = N, Ku = z, Wu = K, zu = Ea;
Oa.f = Gu && !Uu ? Object.defineProperties : function(r, t) {
  Ku(r);
  for (var n = Wu(t), a = zu(t), o = a.length, s = 0, d; o > s; ) Vu.f(r, d = a[s++], n[d]);
  return r;
};
var Hu = Ne, qu = Hu("document", "documentElement"), Yu = z, Ju = Oa, Yt = Yr, Xu = Ue, Zu = qu, Qu = sa, el = qr, Jt = ">", Xt = "<", Rr = "prototype", Ar = "script", xa = el("IE_PROTO"), fr = function() {
}, Pa = function(e) {
  return Xt + Ar + Jt + e + Xt + "/" + Ar + Jt;
}, Zt = function(e) {
  e.write(Pa("")), e.close();
  var r = e.parentWindow.Object;
  return e = null, r;
}, rl = function() {
  var e = Qu("iframe"), r = "java" + Ar + ":", t;
  return e.style.display = "none", Zu.appendChild(e), e.src = String(r), t = e.contentWindow.document, t.open(), t.write(Pa("document.F=Object")), t.close(), t.F;
}, be, Ee = function() {
  try {
    be = new ActiveXObject("htmlfile");
  } catch {
  }
  Ee = typeof document < "u" ? document.domain && be ? Zt(be) : rl() : Zt(be);
  for (var e = Yt.length; e--; ) delete Ee[Rr][Yt[e]];
  return Ee();
};
Xu[xa] = !0;
var Jr = Object.create || function(r, t) {
  var n;
  return r !== null ? (fr[Rr] = Yu(r), n = new fr(), fr[Rr] = null, n[xa] = r) : n = Ee(), t === void 0 ? n : Ju.f(n, t);
}, tl = S, nl = !tl(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), al = M, ol = w, il = Gr, sl = qr, cl = nl, Qt = sl("IE_PROTO"), kr = Object, ul = kr.prototype, Xr = cl ? kr.getPrototypeOf : function(e) {
  var r = il(e);
  if (al(r, Qt)) return r[Qt];
  var t = r.constructor;
  return ol(t) && r instanceof t ? t.prototype : r instanceof kr ? ul : null;
}, ll = re, Zr = function(e, r, t, n) {
  return n && n.enumerable ? e[r] = t : ll(e, r, t), e;
}, vl = S, fl = w, dl = x, pl = Jr, en = Xr, hl = Zr, gl = I, Dr = gl("iterator"), Ra = !1, D, dr, pr;
[].keys && (pr = [].keys(), "next" in pr ? (dr = en(en(pr)), dr !== Object.prototype && (D = dr)) : Ra = !0);
var yl = !dl(D) || vl(function() {
  var e = {};
  return D[Dr].call(e) !== e;
});
yl ? D = {} : D = pl(D);
fl(D[Dr]) || hl(D, Dr, function() {
  return this;
});
var Aa = {
  IteratorPrototype: D,
  BUGGY_SAFARI_ITERATORS: Ra
}, $l = Wr, ml = pe, bl = $l ? {}.toString : function() {
  return "[object " + ml(this) + "]";
}, Sl = Wr, _l = N.f, wl = re, Il = M, Ol = bl, Tl = I, rn = Tl("toStringTag"), Qr = function(e, r, t, n) {
  if (e) {
    var a = t ? e : e.prototype;
    Il(a, rn) || _l(a, rn, { configurable: !0, value: r }), n && !Sl && wl(a, "toString", Ol);
  }
}, El = Aa.IteratorPrototype, xl = Jr, Pl = Me, Rl = Qr, Al = te, kl = function() {
  return this;
}, Dl = function(e, r, t, n) {
  var a = r + " Iterator";
  return e.prototype = xl(El, { next: Pl(+!n, t) }), Rl(e, a, !1, !0), Al[a] = kl, e;
}, jl = _, Cl = Le, Ml = function(e, r, t) {
  try {
    return jl(Cl(Object.getOwnPropertyDescriptor(e, r)[t]));
  } catch {
  }
}, Nl = w, Ll = String, Fl = TypeError, Bl = function(e) {
  if (typeof e == "object" || Nl(e)) return e;
  throw Fl("Can't set " + Ll(e) + " as a prototype");
}, Gl = Ml, Ul = z, Vl = Bl;
Object.setPrototypeOf || "__proto__" in {} && (function() {
  var e = !1, r = {}, t;
  try {
    t = Gl(Object.prototype, "__proto__", "set"), t(r, []), e = r instanceof Array;
  } catch {
  }
  return function(a, o) {
    return Ul(a), Vl(o), e ? t(a, o) : a.__proto__ = o, a;
  };
})();
var Kl = P, Wl = V, zl = ju, Hl = Dl, ql = Xr, Yl = Qr, tn = Zr, Jl = I, nn = te, Xl = Aa, Zl = zl.PROPER, Se = Xl.BUGGY_SAFARI_ITERATORS, hr = Jl("iterator"), an = "keys", _e = "values", on = "entries", Ql = function() {
  return this;
}, et = function(e, r, t, n, a, o, s) {
  Hl(t, r, n);
  var d = function($) {
    if ($ === a && u) return u;
    if (!Se && $ in c) return c[$];
    switch ($) {
      case an:
        return function() {
          return new t(this, $);
        };
      case _e:
        return function() {
          return new t(this, $);
        };
      case on:
        return function() {
          return new t(this, $);
        };
    }
    return function() {
      return new t(this);
    };
  }, l = r + " Iterator", v = !1, c = e.prototype, f = c[hr] || c["@@iterator"] || a && c[a], u = !Se && f || d(a), i = r === "Array" && c.entries || f, p, y, g;
  if (i && (p = ql(i.call(new e())), p !== Object.prototype && p.next && (Yl(p, l, !0, !0), nn[l] = Ql)), Zl && a === _e && f && f.name !== _e && (v = !0, u = function() {
    return Wl(f, this);
  }), a)
    if (y = {
      values: d(_e),
      keys: o ? u : d(an),
      entries: d(on)
    }, s) for (g in y)
      (Se || v || !(g in c)) && tn(c, g, y[g]);
    else Kl({ target: r, proto: !0, forced: Se || v }, y);
  return s && c[hr] !== u && tn(c, hr, u, {}), nn[r] = u, y;
}, rt = function(e, r) {
  return { value: e, done: r };
}, ev = K, sn = te, ka = Ve;
N.f;
var rv = et, we = rt, Da = "Array Iterator", tv = ka.set, nv = ka.getterFor(Da);
rv(Array, "Array", function(e, r) {
  tv(this, {
    type: Da,
    target: ev(e),
    // target
    index: 0,
    // next index
    kind: r
    // kind
  });
}, function() {
  var e = nv(this), r = e.target, t = e.kind, n = e.index++;
  if (!r || n >= r.length)
    return e.target = void 0, we(void 0, !0);
  switch (t) {
    case "keys":
      return we(n, !1);
    case "values":
      return we(r[n], !1);
  }
  return we([n, r[n]], !1);
}, "values");
sn.Arguments = sn.Array;
var av = I, ov = te, iv = av("iterator"), sv = Array.prototype, cv = function(e) {
  return e !== void 0 && (ov.Array === e || sv[iv] === e);
}, uv = pe, cn = Fr, lv = le, vv = te, fv = I, dv = fv("iterator"), ja = function(e) {
  if (!lv(e)) return cn(e, dv) || cn(e, "@@iterator") || vv[uv(e)];
}, pv = V, hv = Le, gv = z, yv = Lr, $v = ja, mv = TypeError, bv = function(e, r) {
  var t = arguments.length < 2 ? $v(e) : r;
  if (hv(t)) return gv(pv(t, e));
  throw mv(yv(e) + " is not iterable");
}, Sv = V, un = z, _v = Fr, wv = function(e, r, t) {
  var n, a;
  un(e);
  try {
    if (n = _v(e, "return"), !n) {
      if (r === "throw") throw t;
      return t;
    }
    n = Sv(n, e);
  } catch (o) {
    a = !0, n = o;
  }
  if (r === "throw") throw t;
  if (a) throw n;
  return un(n), t;
}, Iv = Fe, Ov = V, Tv = z, Ev = Lr, xv = cv, Pv = Be, ln = G, Rv = bv, Av = ja, vn = wv, kv = TypeError, xe = function(e, r) {
  this.stopped = e, this.result = r;
}, fn = xe.prototype, tt = function(e, r, t) {
  var n = t && t.that, a = !!(t && t.AS_ENTRIES), o = !!(t && t.IS_RECORD), s = !!(t && t.IS_ITERATOR), d = !!(t && t.INTERRUPTED), l = Iv(r, n), v, c, f, u, i, p, y, g = function(m) {
    return v && vn(v, "normal", m), new xe(!0, m);
  }, $ = function(m) {
    return a ? (Tv(m), d ? l(m[0], m[1], g) : l(m[0], m[1])) : d ? l(m, g) : l(m);
  };
  if (o)
    v = e.iterator;
  else if (s)
    v = e;
  else {
    if (c = Av(e), !c) throw kv(Ev(e) + " is not iterable");
    if (xv(c)) {
      for (f = 0, u = Pv(e); u > f; f++)
        if (i = $(e[f]), i && ln(fn, i)) return i;
      return new xe(!1);
    }
    v = Rv(e, c);
  }
  for (p = o ? e.next : v.next; !(y = Ov(p, v)).done; ) {
    try {
      i = $(y.value);
    } catch (m) {
      vn(v, "throw", m);
    }
    if (typeof i == "object" && i && ln(fn, i)) return i;
  }
  return new xe(!1);
}, Dv = Vr, jv = N, Cv = Me, Ca = function(e, r, t) {
  var n = Dv(r);
  n in e ? jv.f(e, n, Cv(0, t)) : e[n] = t;
}, Mv = P, Nv = tt, Lv = Ca;
Mv({ target: "Object", stat: !0 }, {
  fromEntries: function(r) {
    var t = {};
    return Nv(r, function(n, a) {
      Lv(t, n, a);
    }, { AS_ENTRIES: !0 }), t;
  }
});
var Fv = W, Bv = Fv.Object.fromEntries, Gv = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, Uv = Gv, Vv = O, Kv = pe, Wv = re, dn = te, zv = I, pn = zv("toStringTag");
for (var gr in Uv) {
  var hn = Vv[gr], yr = hn && hn.prototype;
  yr && Kv(yr) !== pn && Wv(yr, pn, gr), dn[gr] = dn.Array;
}
var Hv = Bv, qv = Hv, Yv = qv, Jv = /* @__PURE__ */ L(Yv), Xv = S, Zv = I, Qv = ra, ef = Zv("species"), rf = function(e) {
  return Qv >= 51 || !Xv(function() {
    var r = [], t = r.constructor = {};
    return t[ef] = function() {
      return { foo: 1 };
    }, r[e](Boolean).foo !== 1;
  });
}, tf = P, nf = Hr.map, af = rf, of = af("map");
tf({ target: "Array", proto: !0, forced: !of }, {
  map: function(r) {
    return nf(this, r, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var sf = de, cf = sf("Array").map, uf = G, lf = cf, $r = Array.prototype, vf = function(e) {
  var r = e.map;
  return e === $r || uf($r, e) && r === $r.map ? lf : r;
}, ff = vf, df = ff, pf = df, hf = /* @__PURE__ */ L(pf), Ma = { exports: {} }, nt = {}, gf = Ta, yf = Yr, $f = yf.concat("length", "prototype");
nt.f = Object.getOwnPropertyNames || function(r) {
  return gf(r, $f);
};
var Na = {}, gn = la, mf = Be, bf = Ca, Sf = Array, _f = Math.max, wf = function(e, r, t) {
  for (var n = mf(e), a = gn(r, n), o = gn(t === void 0 ? n : t, n), s = Sf(_f(o - a, 0)), d = 0; a < o; a++, d++) bf(s, d, e[a]);
  return s.length = d, s;
}, If = U, Of = K, La = nt.f, Tf = wf, Fa = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], Ef = function(e) {
  try {
    return La(e);
  } catch {
    return Tf(Fa);
  }
};
Na.f = function(r) {
  return Fa && If(r) === "Window" ? Ef(r) : La(Of(r));
};
var xf = S, Pf = xf(function() {
  if (typeof ArrayBuffer == "function") {
    var e = new ArrayBuffer(8);
    Object.isExtensible(e) && Object.defineProperty(e, "a", { value: 8 });
  }
}), Rf = S, Af = x, kf = U, yn = Pf, Pe = Object.isExtensible, Df = Rf(function() {
  Pe(1);
}), jf = Df || yn ? function(r) {
  return !Af(r) || yn && kf(r) === "ArrayBuffer" ? !1 : Pe ? Pe(r) : !0;
} : Pe, Cf = S, Mf = !Cf(function() {
  return Object.isExtensible(Object.preventExtensions({}));
}), Nf = P, Lf = _, Ff = Ue, Bf = x, at = M, Gf = N.f, $n = nt, Uf = Na, ot = jf, Vf = Ur, Kf = Mf, Ba = !1, j = Vf("meta"), Wf = 0, it = function(e) {
  Gf(e, j, { value: {
    objectID: "O" + Wf++,
    // object ID
    weakData: {}
    // weak collections IDs
  } });
}, zf = function(e, r) {
  if (!Bf(e)) return typeof e == "symbol" ? e : (typeof e == "string" ? "S" : "P") + e;
  if (!at(e, j)) {
    if (!ot(e)) return "F";
    if (!r) return "E";
    it(e);
  }
  return e[j].objectID;
}, Hf = function(e, r) {
  if (!at(e, j)) {
    if (!ot(e)) return !0;
    if (!r) return !1;
    it(e);
  }
  return e[j].weakData;
}, qf = function(e) {
  return Kf && Ba && ot(e) && !at(e, j) && it(e), e;
}, Yf = function() {
  Jf.enable = function() {
  }, Ba = !0;
  var e = $n.f, r = Lf([].splice), t = {};
  t[j] = 1, e(t).length && ($n.f = function(n) {
    for (var a = e(n), o = 0, s = a.length; o < s; o++)
      if (a[o] === j) {
        r(a, o, 1);
        break;
      }
    return a;
  }, Nf({ target: "Object", stat: !0, forced: !0 }, {
    getOwnPropertyNames: Uf.f
  }));
}, Jf = Ma.exports = {
  enable: Yf,
  fastKey: zf,
  getWeakData: Hf,
  onFreeze: qf
};
Ff[j] = !0;
var Ga = Ma.exports, Xf = G, Zf = TypeError, Ua = function(e, r) {
  if (Xf(r, e)) return e;
  throw Zf("Incorrect invocation");
}, Qf = P, ed = O, rd = Ga, td = S, nd = re, ad = tt, od = Ua, id = w, sd = x, cd = le, ud = Qr, ld = N.f, vd = Hr.forEach, fd = E, Va = Ve, dd = Va.set, pd = Va.getterFor, hd = function(e, r, t) {
  var n = e.indexOf("Map") !== -1, a = e.indexOf("Weak") !== -1, o = n ? "set" : "add", s = ed[e], d = s && s.prototype, l = {}, v;
  if (!fd || !id(s) || !(a || d.forEach && !td(function() {
    new s().entries().next();
  })))
    v = t.getConstructor(r, e, n, o), rd.enable();
  else {
    v = r(function(u, i) {
      dd(od(u, c), {
        type: e,
        collection: new s()
      }), cd(i) || ad(i, u[o], { that: u, AS_ENTRIES: n });
    });
    var c = v.prototype, f = pd(e);
    vd(["add", "clear", "delete", "forEach", "get", "has", "set", "keys", "values", "entries"], function(u) {
      var i = u === "add" || u === "set";
      u in d && !(a && u === "clear") && nd(c, u, function(p, y) {
        var g = f(this).collection;
        if (!i && a && !sd(p)) return u === "get" ? void 0 : !1;
        var $ = g[u](p === 0 ? 0 : p, y);
        return i ? this : $;
      });
    }), a || ld(c, "size", {
      configurable: !0,
      get: function() {
        return f(this).collection.size;
      }
    });
  }
  return ud(v, e, !1, !0), l[e] = v, Qf({ global: !0, forced: !0 }, l), a || t.setStrong(v, e, n), v;
}, gd = N, Ka = function(e, r, t) {
  return gd.f(e, r, t);
}, yd = Zr, $d = function(e, r, t) {
  for (var n in r)
    t && t.unsafe && e[n] ? e[n] = r[n] : yd(e, n, r[n], t);
  return e;
}, md = Ne, bd = Ka, Sd = I, _d = E, mn = Sd("species"), wd = function(e) {
  var r = md(e);
  _d && r && !r[mn] && bd(r, mn, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, Id = Jr, Od = Ka, bn = $d, Td = Fe, Ed = Ua, xd = le, Pd = tt, Rd = et, Ie = rt, Ad = wd, oe = E, Sn = Ga.fastKey, Wa = Ve, _n = Wa.set, mr = Wa.getterFor, kd = {
  getConstructor: function(e, r, t, n) {
    var a = e(function(v, c) {
      Ed(v, o), _n(v, {
        type: r,
        index: Id(null),
        first: void 0,
        last: void 0,
        size: 0
      }), oe || (v.size = 0), xd(c) || Pd(c, v[n], { that: v, AS_ENTRIES: t });
    }), o = a.prototype, s = mr(r), d = function(v, c, f) {
      var u = s(v), i = l(v, c), p, y;
      return i ? i.value = f : (u.last = i = {
        index: y = Sn(c, !0),
        key: c,
        value: f,
        previous: p = u.last,
        next: void 0,
        removed: !1
      }, u.first || (u.first = i), p && (p.next = i), oe ? u.size++ : v.size++, y !== "F" && (u.index[y] = i)), v;
    }, l = function(v, c) {
      var f = s(v), u = Sn(c), i;
      if (u !== "F") return f.index[u];
      for (i = f.first; i; i = i.next)
        if (i.key === c) return i;
    };
    return bn(o, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function() {
        for (var c = this, f = s(c), u = f.index, i = f.first; i; )
          i.removed = !0, i.previous && (i.previous = i.previous.next = void 0), delete u[i.index], i = i.next;
        f.first = f.last = void 0, oe ? f.size = 0 : c.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      delete: function(v) {
        var c = this, f = s(c), u = l(c, v);
        if (u) {
          var i = u.next, p = u.previous;
          delete f.index[u.index], u.removed = !0, p && (p.next = i), i && (i.previous = p), f.first === u && (f.first = i), f.last === u && (f.last = p), oe ? f.size-- : c.size--;
        }
        return !!u;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function(c) {
        for (var f = s(this), u = Td(c, arguments.length > 1 ? arguments[1] : void 0), i; i = i ? i.next : f.first; )
          for (u(i.value, i.key, this); i && i.removed; ) i = i.previous;
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function(c) {
        return !!l(this, c);
      }
    }), bn(o, t ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function(c) {
        var f = l(this, c);
        return f && f.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function(c, f) {
        return d(this, c === 0 ? 0 : c, f);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function(c) {
        return d(this, c = c === 0 ? 0 : c, c);
      }
    }), oe && Od(o, "size", {
      configurable: !0,
      get: function() {
        return s(this).size;
      }
    }), a;
  },
  setStrong: function(e, r, t) {
    var n = r + " Iterator", a = mr(r), o = mr(n);
    Rd(e, r, function(s, d) {
      _n(this, {
        type: n,
        target: s,
        state: a(s),
        kind: d,
        last: void 0
      });
    }, function() {
      for (var s = o(this), d = s.kind, l = s.last; l && l.removed; ) l = l.previous;
      return !s.target || !(s.last = l = l ? l.next : s.state.first) ? (s.target = void 0, Ie(void 0, !0)) : Ie(d === "keys" ? l.key : d === "values" ? l.value : [l.key, l.value], !1);
    }, t ? "entries" : "values", !t, !0), Ad(r);
  }
}, Dd = hd, jd = kd;
Dd("Set", function(e) {
  return function() {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, jd);
var st = _, Cd = Kr, Md = Ge, Nd = ve, Ld = st("".charAt), wn = st("".charCodeAt), Fd = st("".slice), Bd = function(e) {
  return function(r, t) {
    var n = Md(Nd(r)), a = Cd(t), o = n.length, s, d;
    return a < 0 || a >= o ? "" : (s = wn(n, a), s < 55296 || s > 56319 || a + 1 === o || (d = wn(n, a + 1)) < 56320 || d > 57343 ? Ld(n, a) : Fd(n, a, a + 2));
  };
}, Gd = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Bd()
}, Ud = Gd.charAt, Vd = Ge, za = Ve, Kd = et, In = rt, Ha = "String Iterator", Wd = za.set, zd = za.getterFor(Ha);
Kd(String, "String", function(e) {
  Wd(this, {
    type: Ha,
    string: Vd(e),
    index: 0
  });
}, function() {
  var r = zd(this), t = r.string, n = r.index, a;
  return n >= t.length ? In(void 0, !0) : (a = Ud(t, n), r.index += a.length, In(a, !1));
});
var Hd = W, qd = Hd.Set, Yd = qd, Jd = Yd, Xd = Jd, Zd = /* @__PURE__ */ L(Xd), qa = E, Qd = S, Ya = _, ep = Xr, rp = Ea, tp = K, np = Nr.f, Ja = Ya(np), ap = Ya([].push), op = qa && Qd(function() {
  var e = /* @__PURE__ */ Object.create(null);
  return e[2] = 2, !Ja(e, 2);
}), On = function(e) {
  return function(r) {
    for (var t = tp(r), n = rp(t), a = op && ep(t) === null, o = n.length, s = 0, d = [], l; o > s; )
      l = n[s++], (!qa || (a ? l in t : Ja(t, l))) && ap(d, e ? [l, t[l]] : t[l]);
    return d;
  };
}, Xa = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: On(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: On(!1)
}, ip = P, sp = Xa.values;
ip({ target: "Object", stat: !0 }, {
  values: function(r) {
    return sp(r);
  }
});
var cp = W, up = cp.Object.values, lp = up, vp = lp, fp = vp, dp = /* @__PURE__ */ L(fp), pp = P, hp = Xa.entries;
pp({ target: "Object", stat: !0 }, {
  entries: function(r) {
    return hp(r);
  }
});
var gp = W, yp = gp.Object.entries, $p = yp, mp = $p, bp = mp, Sp = /* @__PURE__ */ L(bp);
const Tn = ["prod", "stag", "stag2", "dev1", "preprod"], Za = Jv(hf(Tn).call(Tn, (e) => [e, e === "prod" ? "dixa.io" : `euw1.${e}.dixa.io`]));
function Qa(e) {
  return new Zd(dp(Za)).has(e);
}
function _p(e) {
  if (!e) return "prod";
  for (const [r, t] of Sp(Za))
    if (e === t) return r;
  return "prod";
}
function En(e) {
  e = e.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const t = new RegExp(`[\\?&]${e}=([^&#]*)`).exec(location.search);
  return t === null ? null : wp(t[1].replace(/\+/g, " "));
}
function wp(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    return console.warn(`Failed to decode param value '${e}'`), e;
  }
}
const ct = {
  backendDomain: "dixa:backend-domain"
};
function Ip() {
  const e = En("staging") || En("backend-domain");
  if (e) {
    const r = /^\d+$/.test(e) ? `euw1.stag${e === "1" ? "" : e}.dixa.io` : e;
    return Qa(r) ? (Tp(r), r) : null;
  }
  return null;
}
function Op() {
  var e;
  const r = eu(e = document.cookie.split("; ")).call(e, (n) => yu(n).call(n, `${ct.backendDomain}=`)), t = r ? decodeURIComponent(r.split("=")[1]) : null;
  return t && !Qa(t) ? (Ep(), null) : t;
}
function Tp(e) {
  document.cookie = `${ct.backendDomain}=${encodeURIComponent(e)}; path=/; max-age=31536000; SameSite=Lax`;
}
function Ep() {
  document.cookie = `${ct.backendDomain}=; path=/; max-age=0`;
}
var xn, Pn, Rn, An;
const Oe = window.location.origin.replace(/^https?:\/\//, ""), A = Ip() ?? Op(), B = _p(A), h = {
  // The development domains.
  develop: ["localhost:8080", "dixadev.com", "dixa.io"],
  // The testing domains.
  test: {
    // The security testing domains.
    security: ["dixa-security.com", "dixa-security.net"],
    // The automation testing domains.
    automation: ["localhost:9999", "test-agent-interface.dixa.io", "test.dixatest.com", "okta-test-org.dixatest.com"]
  },
  // The custom subdomains.
  custom: ["thehaddaway.dixa.com", "demo.dixa.com", "developer.dixa.com", "okta-test.dixa.com", "development.dixa.com", "engineering.dixa.com"],
  default: {
    email: "dixa.com",
    emailIntegration: "email.dixa.io",
    integrations: "docs.dixa.io",
    service: "dixa.io",
    status: "status.dixa.io",
    subdomain: "demo",
    userContent: "dixausercontent.com",
    web: "dixa.com",
    accounts: "accounts.dixa.com",
    knowledge: "knowledge-backend-cdn",
    satisfactionSurveyPreview: "csat.reviews"
  }
}, xp = {
  assets: `https://assets.${h.default.service}`,
  toolkit: `https://toolkit.${h.default.service}`,
  widget: `https://widget.${h.default.service}`,
  messenger: B === "prod" ? `https://messenger.${h.default.service}` : `https://messenger.${B}.${h.default.service}`,
  rest: `https://api.${A ?? h.default.service}`,
  advancedInsights: `https://api.${A ?? h.default.service}/v1/advanced-insights/`,
  partnerIntegrations: `https://partner-integrations.${A ?? h.default.service}`,
  files: `https://files.${A ?? h.default.service}`,
  webSocket: `wss://agent-sockets.${A ?? h.default.service}/v2/agent/`,
  userContent: A ? `https://raw.${A.replace(h.default.service, h.default.userContent)}` : `https://raw.${h.default.userContent}`,
  signUp: `https://${h.default.accounts}/signup`,
  logIn: `https://${h.default.accounts}/signin`,
  knowledgeCdn: B === "prod" ? `https://knowledge-backend-cdn.${h.default.service}` : `https://knowledge-backend-cdn.${B}.${h.default.service}`,
  knowledgeApi: `https://knowledge-backend.${A ?? h.default.service}`,
  satisfactionSurveyPreview: B === "prod" ? `https://${h.default.satisfactionSurveyPreview}/preview.html` : `https://stag.${h.default.satisfactionSurveyPreview}/preview.html`
}, Pp = {
  amplitude: {
    environment: me(xn = [...h.test.automation, ...h.develop, ...h.test.security, ...h.custom]).call(xn, Oe) || B !== "prod" ? "stag" : "prod"
  },
  launchDarkly: me(Pn = h.develop).call(Pn, Oe) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
  stripe: me(Rn = h.develop).call(Rn, Oe) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
  elevio: "599d54aacd7bd",
  birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
  jabra: {
    partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
    appId: "Dixa",
    appName: "Dixa"
  },
  messenger: {
    token: {
      prod: me(An = h.develop).call(An, Oe) ? "95b2b555c0b046a18e5d508837811008" : "7c08132d4bf5d5f1bf4432133ef8254e3262f9ef",
      // support.dixa.com
      stag: "0a76a5650f3540dc8bad030e54aa2e22",
      // engineering.dixa.com (stag)
      stag2: "0a76a5650f3540dc8bad030e54aa2e22",
      // engineering.dixa.com (stag2)
      dev1: "414a01b7802f4d4bb61a6ab6aaacd442",
      // engineering.dixa.com (dev1)
      preprod: ""
    }
  }
}, ce = {
  environment: B,
  domain: h.default,
  sdk: Pp,
  url: xp,
  backendDomain: A
};
class Rp {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const kn = new Rp();
function Ap(e, r) {
  return Dn(e), Dn(r), e.localeCompare(r, void 0, {
    numeric: !0
  });
}
function Dn(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const kp = Object.prototype.toString;
function Dp(e, r) {
  return kp.call(e) === `[object ${r}]`;
}
function jp(e) {
  return Dp(e, "Object");
}
function Cp(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const ie = "8.36.0", C = globalThis;
function ut(e, r, t) {
  const n = t || C, a = n.__SENTRY__ = n.__SENTRY__ || {}, o = a[ie] = a[ie] || {};
  return o[e] || (o[e] = r());
}
const eo = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Mp = "Sentry Logger ", jn = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Cn = {};
function ro(e) {
  if (!("console" in C))
    return e();
  const r = C.console, t = {}, n = Object.keys(Cn);
  n.forEach((a) => {
    const o = Cn[a];
    t[a] = r[a], r[a] = o;
  });
  try {
    return e();
  } finally {
    n.forEach((a) => {
      r[a] = t[a];
    });
  }
}
function Np() {
  let e = !1;
  const r = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return eo ? jn.forEach((t) => {
    r[t] = (...n) => {
      e && ro(() => {
        C.console[t](`${Mp}[${t}]:`, ...n);
      });
    };
  }) : jn.forEach((t) => {
    r[t] = () => {
    };
  }), r;
}
const Re = ut("logger", Np);
function Lp(e, r, t) {
  try {
    Object.defineProperty(e, r, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    eo && Re.log(`Failed to add non-enumerable property "${r}" to object`, e);
  }
}
const to = 1e3;
function lt() {
  return Date.now() / to;
}
function Fp() {
  const { performance: e } = C;
  if (!e || !e.now)
    return lt;
  const r = Date.now() - e.now(), t = e.timeOrigin == null ? r : e.timeOrigin;
  return () => (t + e.now()) / to;
}
const Bp = Fp();
(() => {
  const { performance: e } = C;
  if (!e || !e.now)
    return;
  const r = 3600 * 1e3, t = e.now(), n = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + t - n) : r, o = a < r, s = e.timing && e.timing.navigationStart, l = typeof s == "number" ? Math.abs(s + t - n) : r, v = l < r;
  return o || v ? a <= l ? e.timeOrigin : s : n;
})();
function X() {
  const e = C, r = e.crypto || e.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (r && r.randomUUID)
      return r.randomUUID().replace(/-/g, "");
    r && r.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return r.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
function Mn() {
  return {
    traceId: X(),
    spanId: X().substring(16)
  };
}
function vt() {
  return ft(C), C;
}
function ft(e) {
  const r = e.__SENTRY__ = e.__SENTRY__ || {};
  return r.version = r.version || ie, r[ie] = r[ie] || {};
}
function Gp(e, r = {}) {
  if (r.user && (!e.ipAddress && r.user.ip_address && (e.ipAddress = r.user.ip_address), !e.did && !r.did && (e.did = r.user.id || r.user.email || r.user.username)), e.timestamp = r.timestamp || Bp(), r.abnormal_mechanism && (e.abnormal_mechanism = r.abnormal_mechanism), r.ignoreDuration && (e.ignoreDuration = r.ignoreDuration), r.sid && (e.sid = r.sid.length === 32 ? r.sid : X()), r.init !== void 0 && (e.init = r.init), !e.did && r.did && (e.did = `${r.did}`), typeof r.started == "number" && (e.started = r.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof r.duration == "number")
    e.duration = r.duration;
  else {
    const t = e.timestamp - e.started;
    e.duration = t >= 0 ? t : 0;
  }
  r.release && (e.release = r.release), r.environment && (e.environment = r.environment), !e.ipAddress && r.ipAddress && (e.ipAddress = r.ipAddress), !e.userAgent && r.userAgent && (e.userAgent = r.userAgent), typeof r.errors == "number" && (e.errors = r.errors), r.status && (e.status = r.status);
}
const jr = "_sentrySpan";
function Nn(e, r) {
  r ? Lp(e, jr, r) : delete e[jr];
}
function Ln(e) {
  return e[jr];
}
const Up = 100;
class dt {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Mn();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const r = new dt();
    return r._breadcrumbs = [...this._breadcrumbs], r._tags = { ...this._tags }, r._extra = { ...this._extra }, r._contexts = { ...this._contexts }, r._user = this._user, r._level = this._level, r._session = this._session, r._transactionName = this._transactionName, r._fingerprint = this._fingerprint, r._eventProcessors = [...this._eventProcessors], r._requestSession = this._requestSession, r._attachments = [...this._attachments], r._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, r._propagationContext = { ...this._propagationContext }, r._client = this._client, r._lastEventId = this._lastEventId, Nn(r, Ln(this)), r;
  }
  /**
   * @inheritDoc
   */
  setClient(r) {
    this._client = r;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(r) {
    this._lastEventId = r;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(r) {
    this._scopeListeners.push(r);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(r) {
    return this._eventProcessors.push(r), this;
  }
  /**
   * @inheritDoc
   */
  setUser(r) {
    return this._user = r || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Gp(this._session, { user: r }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(r) {
    return this._requestSession = r, this;
  }
  /**
   * @inheritDoc
   */
  setTags(r) {
    return this._tags = {
      ...this._tags,
      ...r
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(r, t) {
    return this._tags = { ...this._tags, [r]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(r) {
    return this._extra = {
      ...this._extra,
      ...r
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(r, t) {
    return this._extra = { ...this._extra, [r]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(r) {
    return this._fingerprint = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(r) {
    return this._level = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(r) {
    return this._transactionName = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(r, t) {
    return t === null ? delete this._contexts[r] : this._contexts[r] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(r) {
    return r ? this._session = r : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(r) {
    if (!r)
      return this;
    const t = typeof r == "function" ? r(this) : r, [n, a] = t instanceof Q ? [t.getScopeData(), t.getRequestSession()] : jp(t) ? [r, r.requestSession] : [], { tags: o, extra: s, user: d, contexts: l, level: v, fingerprint: c = [], propagationContext: f } = n || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...l }, d && Object.keys(d).length && (this._user = d), v && (this._level = v), c.length && (this._fingerprint = c), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Nn(this, void 0), this._attachments = [], this._propagationContext = Mn(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(r, t) {
    const n = typeof t == "number" ? t : Up;
    if (n <= 0)
      return this;
    const a = {
      timestamp: lt(),
      ...r
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > n ? o.slice(-n) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(r) {
    return this._attachments.push(r), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Ln(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(r) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...r }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(r) {
    return this._propagationContext = r, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(r, t) {
    const n = t && t.event_id ? t.event_id : X();
    if (!this._client)
      return Re.warn("No client configured on scope - will not capture exception!"), n;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      r,
      {
        originalException: r,
        syntheticException: a,
        ...t,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * @inheritDoc
   */
  captureMessage(r, t, n) {
    const a = n && n.event_id ? n.event_id : X();
    if (!this._client)
      return Re.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(r);
    return this._client.captureMessage(
      r,
      t,
      {
        originalException: r,
        syntheticException: o,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(r, t) {
    const n = t && t.event_id ? t.event_id : X();
    return this._client ? (this._client.captureEvent(r, { ...t, event_id: n }, this), n) : (Re.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((r) => {
      r(this);
    }), this._notifyingListeners = !1);
  }
}
const Q = dt;
function Vp() {
  return ut("defaultCurrentScope", () => new Q());
}
function Kp() {
  return ut("defaultIsolationScope", () => new Q());
}
class Wp {
  constructor(r, t) {
    let n;
    r ? n = r : n = new Q();
    let a;
    t ? a = t : a = new Q(), this._stack = [{ scope: n }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(r) {
    const t = this._pushScope();
    let n;
    try {
      n = r(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return Cp(n) ? n.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const r = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: r
    }), r;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function ee() {
  const e = vt(), r = ft(e);
  return r.stack = r.stack || new Wp(Vp(), Kp());
}
function zp(e) {
  return ee().withScope(e);
}
function Hp(e, r) {
  const t = ee();
  return t.withScope(() => (t.getStackTop().scope = e, r(e)));
}
function Fn(e) {
  return ee().withScope(() => e(ee().getIsolationScope()));
}
function qp() {
  return {
    withIsolationScope: Fn,
    withScope: zp,
    withSetScope: Hp,
    withSetIsolationScope: (e, r) => Fn(r),
    getCurrentScope: () => ee().getScope(),
    getIsolationScope: () => ee().getIsolationScope()
  };
}
function no(e) {
  const r = ft(e);
  return r.acs ? r.acs : qp();
}
function pt() {
  const e = vt();
  return no(e).getCurrentScope();
}
function ao() {
  const e = vt();
  return no(e).getIsolationScope();
}
function Yp() {
  return pt().getClient();
}
function Jp(e) {
  if (e)
    return Xp(e) ? { captureContext: e } : Qp(e) ? {
      captureContext: e
    } : e;
}
function Xp(e) {
  return e instanceof Q || typeof e == "function";
}
const Zp = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function Qp(e) {
  return Object.keys(e).some((r) => Zp.includes(r));
}
function Bn(e, r) {
  return pt().captureException(e, Jp(r));
}
function eh(e, r) {
  const t = typeof r == "string" ? r : void 0, n = typeof r != "string" ? { captureContext: r } : void 0;
  return pt().captureMessage(e, t, n);
}
function rh(e, r) {
  ao().setContext(e, r);
}
const th = 100;
function F(e, r) {
  const t = Yp(), n = ao();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = th } = t.getOptions();
  if (o <= 0) return;
  const d = { timestamp: lt(), ...e }, l = a ? ro(() => a(d, r)) : d;
  l !== null && (t.emit && t.emit("beforeAddBreadcrumb", l, r), n.addBreadcrumb(l, o));
}
var ue;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(ue || (ue = {}));
function Z(e) {
  const r = e.split(".")[1];
  if (!r)
    throw Error("Invalid token");
  const t = r.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (n) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${n}`);
  }
}
const nh = ce.backendDomain ? {
  "backend-domain": ce.backendDomain
} : void 0;
function Ae() {
  const e = new URLSearchParams({
    noToken: "true",
    ...nh
  }).toString();
  document.location.href = `${ce.url.logIn}?${e}`;
}
const br = "authData", Sr = 30, ah = 600, _r = 5;
class oh {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const r = Date.now() / 1e3;
    return this.clientServerTimeDiff >= _r || this.clientServerTimeDiff <= -_r ? Math.ceil(r + this.clientServerTimeDiff) : Math.ceil(r);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(r) {
    this.authData = r;
    const n = Math.ceil(Date.now() / 1e3) + ah, a = Z(r.access_token).exp;
    if (this.clientServerTimeDiff = a - n, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > _r) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(br, JSON.stringify(r));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const r = localStorage.getItem(br), t = r ? JSON.parse(r) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(br);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(r) {
    return r ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((n) => typeof r[n] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - Sr;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(r) {
    if (!r)
      return !0;
    const t = Z(r), n = t.exp - Sr;
    return !t || this.estimatedServerTime() >= n;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Sr - this.estimatedServerTime()) * 1e3;
  }
}
const b = new oh();
async function ih(e) {
  const r = window.location.origin.replace(/^https?:\/\//, ""), t = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || t.some((n) => r.includes(n)))) {
    try {
      const n = e.response.config.headers.Authorization ?? "", a = n ? n.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Z(o).exp : "None", d = await ht.getAuthData({ localStorageOnly: !0 }), l = Math.floor(Date.now() / 1e3), v = d?.access_token, c = d?.refresh_token, f = v ? Z(v).exp : "None", u = c ? Z(c).exp : "None", i = typeof s == "number" ? l - s : "Unknown", p = typeof f == "number" ? l - f : "Unknown", y = typeof u == "number" ? l - u : "Unknown", g = e.response.headers["x-dixa-rid"];
      rh("Expires", {
        currentTimestamp: l,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: i,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: p,
        refreshTokenFromLocalStorage: u,
        refreshTokenFromLocalStorageDiff: y,
        xDixaRid: g,
        navigatorOnline: navigator.onLine
      });
    } catch (n) {
      console.error("Error adding Sentry error context", n);
    }
    eh("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: ue.Platform,
        domain: r
      }
    });
  }
}
const wr = /* @__PURE__ */ new Map(), sh = 3;
function ch(e) {
  e.interceptors.response.use((r) => (wr.delete(r.config.url), r), (r) => {
    if (r.response) {
      const { status: t } = r.response;
      switch (t) {
        case Cr.Unauthorized:
          if (!ht.isRefreshTokenExpired() && r.config) {
            F({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const n = wr.get(r.config.url) ?? 0;
            if (console.log(`Retrying request (${n + 1}): ${r.config.url}`), n <= sh)
              return wr.set(r.config.url, n + 1), e(r.config);
          }
          ih(r), console.error("401 unauthorized interceptor"), Ae();
          break;
      }
    }
    return Promise.reject(r);
  });
}
const oo = Un.create();
ch(oo);
const k = console.log;
async function Gn(e) {
  return new Promise((r) => setTimeout(r, e * 1e3));
}
class uh extends Error {
  constructor(r, t) {
    super(r, t);
  }
}
function lh(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const vh = 5;
class fh {
  authDataPromise = null;
  retryCount = 0;
  async init(r) {
    const t = await this.refresh(r);
    if (t)
      b.setAuthData(t);
    else {
      const n = b.isRefreshTokenExpired(r) ? "expired" : "unknown";
      throw new uh("Failed to init refresh token", {
        cause: n
      });
    }
  }
  getDebugInfo() {
    const r = b.getAccessToken();
    if (!r)
      return {};
    const t = Z(r), { exp: n } = t;
    return {
      expire: n ? new Date(n * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: r = !1 } = {}) {
    if (r)
      return b.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const t = b.getAuthData();
    return t ? b.isAccessTokenExpired() ? (F({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(t.refresh_token).then((n) => (n && b.setAuthData(n), this.authDataPromise = null, n)), await this.authDataPromise) : t : null;
  }
  removeAuthData() {
    return b.removeAuthData();
  }
  validateAuthDataComplete(r) {
    return b.validateAuthDataComplete(r);
  }
  isAccessTokenExpired() {
    return b.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const r = b.getAuthData();
    return r ? b.isRefreshTokenExpired(r.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!kn.isElectron())
      return !0;
    const r = await kn.getVersion();
    return Ap(r, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(r, t = vh) {
    try {
      return await oo.post(`${ce.url.rest}/v2/login/refresh`, {
        refreshToken: r
      }).then((n) => (this.retryCount = 0, n.data.data));
    } catch (n) {
      return await this.handleRefreshError(n, r, t);
    }
  }
  async waitUntilOnline() {
    const r = navigator.onLine === !1;
    for (r && (k("AUTH", "Network connection offline - waiting..."), F({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Gn(5);
    r && (k("AUTH", "Network connection restored"), F({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(r, t) {
    await this.waitUntilOnline(), this.retryCount++;
    const n = lh(this.retryCount);
    return k("AUTH", `Retrying in ${n} seconds`), await Gn(n), await this.refresh(r, t);
  }
  async handleRefreshError(r, t, n) {
    if (b.isRefreshTokenExpired(t))
      return k("AUTH", "Refresh token expired"), F({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), b.removeAuthData(), Ae(), null;
    if (io(r)) {
      if (r.message === "timeout exceeded")
        return k("AUTH", "Timeout exceeded"), F({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(t, n);
      if (r.message === "Network Error")
        return k("AUTH", "Network error"), F({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(t, n);
      if (r.response?.status === 401)
        return k("AUTH", "Refresh token invalid (401)"), b.removeAuthData(), Ae(), null;
      Bn(r, {
        level: "error",
        tags: {
          team: ue.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return n <= 0 ? (k("AUTH", "Retries exhausted, logging out"), Bn(r, {
      level: "error",
      tags: {
        team: ue.Platform,
        errorSource: "authManager.refresh"
      }
    }), b.removeAuthData(), Ae(), null) : (k("AUTH", `Retrying ${n} more times`), await this.retryRefresh(t, n - 1));
  }
  accessTokenExpiresInMs() {
    return b.accessTokenExpiresInMs();
  }
}
const ht = new fh();
var Cr;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Cr || (Cr = {}));
const dh = Un.create();
class ph {
  /** The current logged in user. */
  user = null;
  /** The list of authorization scopes assigned to the current user. */
  scopes = null;
  /** This list of user roles assigned to the current user */
  _roles = null;
  /** Checks if the service has been initialized. */
  get isInitialized() {
    return this.user !== null;
  }
  /** Initializes the access control service. */
  async init({
    user: r
  }) {
    this.user = r;
    const t = await this.introspectAccessToken();
    t && (this.scopes = t.scope, this._roles = t.roles);
  }
  /** Exposed read-only list of user roles assigned to the current user */
  get roles() {
    return this._roles;
  }
  /**
   * Checks if the current user has access to one or more scopes.
   *
   * @param scopes - The scope(s) to check.
   * @param options - The options to use when checking multiple scopes.
   * @param options.strategy - The strategy to use when checking multiple
   *   scopes. Can be "all" or "any".
   * @returns Whether or not the user has access to the scope(s).
   */
  hasAccess(r, t) {
    if (!this.isInitialized || this.scopes === null)
      return !1;
    if (Array.isArray(r)) {
      const { strategy: n = "all" } = t ?? {};
      return n === "all" ? r.every(this.hasScope) : r.some(this.hasScope);
    }
    return this.scopes.includes(r);
  }
  /** Checks if the user has a certain scope. */
  hasScope = (r) => this.scopes.includes(r);
  /**
   * Fetches the introspection data of the current access_token and stores it in
   * memory. This should be called only once on init.
   */
  async introspectAccessToken() {
    const r = await ht.getAuthData({ localStorageOnly: !0 });
    if (!r) return null;
    try {
      return (await dh.post(
        `${ce.url.rest}/v1/introspect`,
        {
          token: r.access_token
        },
        {
          transformResponse: (n) => {
            const a = JSON.parse(n);
            return {
              ...a,
              /**
               * As per the spec, the backend returns the `scope` as a
               * space-separated string. We convert it to an array of strings to
               * make it easier for us.
               *
               * @see https://datatracker.ietf.org/doc/html/rfc7662#section-2.2
               */
              scope: a.scope ? a.scope.split(" ") : []
            };
          }
        }
      )).data;
    } catch {
      return null;
    }
  }
  reset() {
    this.user = null, this.scopes = null, this._roles = null;
  }
}
const hh = new ph(), $h = (e, r) => so(
  () => hh.hasAccess(e, r),
  // The arguments are statically defined when consuming the hook, therefore we don't need to
  // recompute the result on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);
export {
  hh as accessControl,
  $h as useHasAccess
};
//# sourceMappingURL=index.js.map
